// VRT header — mobile drawer open/close. Mega-menu is CSS-only (hover/focus).
// The desktop "Cart" button and the drawer's "Bag" button carry
// [data-vrt-cart-toggle]; vrt-cart.js handles those globally.

class VrtHeader extends HTMLElement {
  connectedCallback() {
    this.toggles = this.querySelectorAll('[data-vrt-menu-toggle]');
    this.closers = this.querySelectorAll('[data-vrt-menu-close]');
    this.drawer = this.querySelector('.vrt-header__drawer');

    this.toggles.forEach((el) => el.addEventListener('click', () => this.toggle()));
    this.closers.forEach((el) => el.addEventListener('click', () => this.close()));

    this._onKey = (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
    };
    document.addEventListener('keydown', this._onKey);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onKey);
  }

  toggle() {
    this.classList.contains('is-open') ? this.close() : this.open();
  }

  open() {
    this.classList.add('is-open');
    document.body.classList.add('vrt-no-scroll');
    this.toggles.forEach((el) => el.setAttribute('aria-expanded', 'true'));
    if (this.drawer) this.drawer.setAttribute('aria-hidden', 'false');
    const firstClose = this.querySelector('.vrt-header__drawer-close');
    if (firstClose) firstClose.focus();
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('vrt-no-scroll');
    this.toggles.forEach((el) => el.setAttribute('aria-expanded', 'false'));
    if (this.drawer) this.drawer.setAttribute('aria-hidden', 'true');
  }
}

if (!customElements.get('vrt-header')) {
  customElements.define('vrt-header', VrtHeader);
}
